import React from "react";
import {
  ArrowRight,
  Boxes,
  Brain,
  ChartColumn,
  Compass,
  CreditCard,
  Factory,
  FlaskConical,
  GraduationCap,
  HeartPulse,
  Landmark,
  Layers,
  MessageCircle,
  PackageSearch,
  Plug,
  Receipt,
  ShieldCheck,
  ShoppingBag,
  TrendingUp,
  Truck,
  Users,
  Wallet,
  Workflow,
} from "lucide-react";
import { useAura } from "./AuraProvider";

// The backend names each card's icon (knowledge.py CARDS); unknown names get the compass.
const ICONS = {
  boxes: Boxes,
  brain: Brain,
  "bar-chart-3": ChartColumn,
  "credit-card": CreditCard,
  factory: Factory,
  "flask-conical": FlaskConical,
  "graduation-cap": GraduationCap,
  "heart-pulse": HeartPulse,
  landmark: Landmark,
  layers: Layers,
  "message-circle": MessageCircle,
  "package-search": PackageSearch,
  plug: Plug,
  receipt: Receipt,
  "shield-check": ShieldCheck,
  "shopping-bag": ShoppingBag,
  "trending-up": TrendingUp,
  truck: Truck,
  users: Users,
  wallet: Wallet,
  workflow: Workflow,
};

// A preview card under Simmi's reply: a service, product, industry or result (show_card), or a page (show_page).
const SimmiCard = ({ action, onNavigate, compact = false }) => {
  const { t } = useAura();
  const Icon = ICONS[action.icon] || Compass;
  const title = action.type === "open_page" ? action.label : action.title;
  return (
    <button
      type="button"
      onClick={() => onNavigate(action.path)}
      className="simmi-card group flex w-full items-start gap-3 rounded-[14px] border border-white/10 bg-white/[0.05] p-3 text-left transition-all hover:-translate-y-0.5 hover:border-[#06D3DB]/40 hover:bg-white/[0.08]"
    >
      <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[10px] bg-gradient-to-br from-[#2563EB]/40 to-[#06D3DB]/25 text-[#06D3DB]">
        <Icon className="h-[18px] w-[18px]" />
      </span>
      <span className="flex min-w-0 flex-1 flex-col gap-1">
        <span className="text-[13.5px] font-semibold leading-[18px] text-white">{title}</span>
        {action.blurb && !compact && <span className="text-[12px] leading-[17px] text-white/65">{action.blurb}</span>}
        <span className="mt-0.5 flex flex-wrap items-center gap-2">
          {action.stat && (
            <span className="rounded-full bg-[#06D3DB]/15 px-2 py-0.5 text-[11px] font-semibold text-[#06D3DB]">{action.stat}</span>
          )}
          <span className="inline-flex items-center gap-1 text-[11.5px] font-medium text-white/70 transition-colors group-hover:text-white">
            {t.explore} <ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" />
          </span>
        </span>
      </span>
    </button>
  );
};

export default SimmiCard;
